import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

// Define a type for the slice state
interface pagesState {
  pages: number[]
}

// Define the initial state using that type
const initialState: pagesState = {
  pages: []
}

export const rememberPageSlice = createSlice({
  name: 'pagination',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    saveCurrentPage: (state, action: PayloadAction<number>) => {
      state.pages.push(action.payload)
    },
    removeLastPageIndex: (state: pagesState) => {
      if (state.pages.length > 1) {
        state.pages.splice(state.pages.length - 1, 1)
      }
    },
    removeAllPage: (state: pagesState) => {
      state.pages = []
    }
  }
})
export const { saveCurrentPage, removeLastPageIndex, removeAllPage } = rememberPageSlice.actions

export default rememberPageSlice.reducer
